import { FormControl, Grid, TextField, Typography } from '@mui/material'

// Imports custom
import { MoraPendienteTable } from './MoraPendienteTable'

export const MoraExemption = ({ useFetchInit }) => {

    const { Forms } = useFetchInit
    const { FormRequestGlobal: { formState } } = Forms

    return (
        <>
            <Typography sx={{ mt: 3, fontWeight: 'bold' }} variant='subtitle2'>
                Cuotas seleccionadas para exoneracion de mora
            </Typography>
            <div className="border-bottom border-dark"></div>
            <MoraPendienteTable useFetchInit={useFetchInit} />

            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 2, mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="porcentaje_exoneracion">% Exoneracion solicitado</label>
                        <TextField
                            id='porcentaje_exoneracion'
                            name='porcentaje_exoneracion'
                            value={formState.porcentaje_exoneracion}
                            size='small'
                            placeholder='% Exoneracion'
                            hiddenLabel
                            type='text'
                            variant='filled'
                            InputProps={{ readOnly: true }}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="total_exoneracion">
                            {formState.aprobacion_check === 'Aprobado' ? 'Total exonerado (aprobado)' : 'Total solicitado a exonerar'}
                        </label>
                        <TextField
                            id='total_exoneracion'
                            name='total_exoneracion'
                            value={formState.total_exoneracion}
                            size='small'
                            placeholder='Total a exonerar'
                            hiddenLabel
                            type='text'
                            variant='filled'
                            InputProps={{ readOnly: true }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
